import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { useVehicles } from '../contexts/VehiclesContext';
import { VehicleCard } from './VehicleCard';
import { CompraVentaForm } from './CompraVentaForm';
import { stockVehicles } from '../data/stockVehicles';
import { ANIOS, MARCAS } from '../types/vehicle';
const selectClass = 'w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white text-sm focus:border-brand-gold outline-none transition-colors';
export function Stock() {
  const {
    vehicles
  } = useVehicles();
  const [marca, setMarca] = useState('');
  const [anio, setAnio] = useState('');
  const allVehicles = useMemo(() => [...vehicles, ...stockVehicles], [vehicles]);
  const filtered = useMemo(() => allVehicles.filter(v => (!marca || v.marca === marca) && (!anio || v.anio === anio)), [allVehicles, marca, anio]);
  const hasFilters = Boolean(marca || anio);
  const clearFilters = () => {
    setMarca('');
    setAnio('');
  };
  return <section id="stock" className="py-32 bg-brand-black relative scroll-mt-20" data-id="element-464" data-mp="350smkl0bcpix">
      <div className="max-w-7xl mx-auto px-5 sm:px-6" data-id="element-465" data-mp="39zcd6ypuqphm">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-466" data-mp="3ezi60i7uyi1a">
          <h2 className="font-heading text-5xl md:text-6xl text-brand-white mb-3" data-id="element-467" data-mp="3iyqxthjc85u7">
            Compra y Venta — Nuestro Stock
          </h2>
          <p className="text-xl text-brand-gold" data-id="element-468" data-mp="2rayyw60jobas">
            Todos nuestros vehículos disponibles
          </p>
        </motion.div>

        {/* Filters */}
        <div className="bg-[#111] border border-brand-gold/20 rounded-xl p-5 sm:p-6 mb-12" data-id="element-469" data-mp="3027mcll2a5uh">
          <div className="grid sm:grid-cols-2 gap-4" data-id="element-470" data-mp="3042ae8rmqe2s">
            <div data-id="element-471" data-mp="23jjso25nd9u9">
              <label htmlFor="filtro-marca" className="sr-only" data-id="element-472" data-mp="23k2zampukbsz">
                Marca
              </label>
              <select id="filtro-marca" value={marca} onChange={e => setMarca(e.target.value)} className={selectClass} data-id="element-473" data-mp="27jtxhbhpdu7j">
                <option value="" data-id="element-474" data-mp="35vn32tzswghp">Todas las marcas</option>
                {MARCAS.map(m => <option key={m} value={m} data-id="element-475" data-mp="3koq8k304b3s2">
                    {m}
                  </option>)}
              </select>
            </div>
            <div data-id="element-476" data-mp="2rx6lu94bb7lb">
              <label htmlFor="filtro-anio" className="sr-only" data-id="element-477" data-mp="2ryrgrzujgsjp">
                Año
              </label>
              <select id="filtro-anio" value={anio} onChange={e => setAnio(e.target.value)} className={selectClass} data-id="element-478" data-mp="2n0g47hcv03xs">
                <option value="" data-id="element-479" data-mp="2wvhuigivfc1y">Todos los años</option>
                {ANIOS.map(a => <option key={a} value={a} data-id="element-480" data-mp="g7478eklqlk3">
                    {a}
                  </option>)}
              </select>
            </div>
          </div>

          <div className="flex items-center justify-between gap-4 mt-5" data-id="element-481" data-mp="jptm7bzx5uqp">
            <p className="text-brand-white/50 text-sm" data-id="element-482" data-mp="opfz1kbu58yz">
              {filtered.length}{' '}
              {filtered.length === 1 ? 'vehículo' : 'vehículos'}
            </p>
            <button type="button" onClick={clearFilters} className="px-5 py-2.5 border border-brand-gold text-brand-gold text-sm font-bold rounded hover:bg-brand-gold hover:text-brand-black transition-colors" data-id="element-483" data-mp="9tzzx0weemvq">
              Limpiar filtros
            </button>
          </div>
        </div>

        {/* Grid */}
        {filtered.length > 0 ? <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-484" data-mp="sqrj7abxx1zs">
            {filtered.map(v => <VehicleCard key={v.id} vehicle={v} data-id="element-485" data-mp="xo1db3a9y1ty" />)}
          </div> : <div className="text-center py-16" data-id="element-486" data-mp="1ldly7rpzn95v">
            <p className="text-brand-white/60 mb-6" data-id="element-487" data-mp="1q6ova9tz50qt">
              No encontramos vehículos con esos filtros.
            </p>
            {hasFilters && <button type="button" onClick={clearFilters} className="px-6 py-3 bg-brand-gold text-brand-black font-bold text-sm rounded hover:bg-brand-white transition-colors" data-id="element-488" data-mp="2g0v5a0hxtou">
                Ver todo el stock
              </button>}
          </div>}

        <CompraVentaForm data-id="element-489" data-mp="l94oeu9sy4ix" />
      </div>

      {/* Divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-490" data-mp="lao9cy6el3r1"></div>
    </section>;
}